__turbopack_context__.v({
  "chipsScroll": "SearchModal-module-scss-module__VIIjUq__chipsScroll",
  "dividerLight": "SearchModal-module-scss-module__VIIjUq__dividerLight",
  "empty": "SearchModal-module-scss-module__VIIjUq__empty",
  "feedLabel": "SearchModal-module-scss-module__VIIjUq__feedLabel",
  "filterChip": "SearchModal-module-scss-module__VIIjUq__filterChip",
  "highlight": "SearchModal-module-scss-module__VIIjUq__highlight",
  "iconCell": "SearchModal-module-scss-module__VIIjUq__iconCell",
  "itemBody": "SearchModal-module-scss-module__VIIjUq__itemBody",
  "itemBtn": "SearchModal-module-scss-module__VIIjUq__itemBtn",
  "itemContent": "SearchModal-module-scss-module__VIIjUq__itemContent",
  "itemContentCompact": "SearchModal-module-scss-module__VIIjUq__itemContentCompact",
  "itemSelected": "SearchModal-module-scss-module__VIIjUq__itemSelected",
  "itemTitle": "SearchModal-module-scss-module__VIIjUq__itemTitle",
  "itemTitleRow": "SearchModal-module-scss-module__VIIjUq__itemTitleRow",
  "itemsList": "SearchModal-module-scss-module__VIIjUq__itemsList",
  "kbdChip": "SearchModal-module-scss-module__VIIjUq__kbdChip",
  "keyboardHintLabel": "SearchModal-module-scss-module__VIIjUq__keyboardHintLabel",
  "keyboardHints": "SearchModal-module-scss-module__VIIjUq__keyboardHints",
  "loadingPad": "SearchModal-module-scss-module__VIIjUq__loadingPad",
  "metaBullet": "SearchModal-module-scss-module__VIIjUq__metaBullet",
  "metaTag": "SearchModal-module-scss-module__VIIjUq__metaTag",
  "mobileHandle": "SearchModal-module-scss-module__VIIjUq__mobileHandle",
  "mobileHandleWrap": "SearchModal-module-scss-module__VIIjUq__mobileHandleWrap",
  "overlay": "SearchModal-module-scss-module__VIIjUq__overlay",
  "packageBadge": "SearchModal-module-scss-module__VIIjUq__packageBadge",
  "panel": "SearchModal-module-scss-module__VIIjUq__panel",
  "portalRoot": "SearchModal-module-scss-module__VIIjUq__portalRoot",
  "resultsSection": "SearchModal-module-scss-module__VIIjUq__resultsSection",
  "rowIconSvg": "SearchModal-module-scss-module__VIIjUq__rowIconSvg",
  "rowIconWrap": "SearchModal-module-scss-module__VIIjUq__rowIconWrap",
  "scrollArea": "SearchModal-module-scss-module__VIIjUq__scrollArea",
  "searchBarContainer": "SearchModal-module-scss-module__VIIjUq__searchBarContainer",
  "searchDismiss": "SearchModal-module-scss-module__VIIjUq__searchDismiss",
  "searchInput": "SearchModal-module-scss-module__VIIjUq__searchInput",
  "searchModalDesktopIn": "SearchModal-module-scss-module__VIIjUq__searchModalDesktopIn",
  "searchModalDesktopOut": "SearchModal-module-scss-module__VIIjUq__searchModalDesktopOut",
  "searchModalOverlayIn": "SearchModal-module-scss-module__VIIjUq__searchModalOverlayIn",
  "searchModalOverlayOut": "SearchModal-module-scss-module__VIIjUq__searchModalOverlayOut",
  "searchModalSheetIn": "SearchModal-module-scss-module__VIIjUq__searchModalSheetIn",
  "searchModalSheetOut": "SearchModal-module-scss-module__VIIjUq__searchModalSheetOut",
  "searchRow": "SearchModal-module-scss-module__VIIjUq__searchRow",
  "sectionHeading": "SearchModal-module-scss-module__VIIjUq__sectionHeading",
  "shortDesc": "SearchModal-module-scss-module__VIIjUq__shortDesc",
  "statusDot": "SearchModal-module-scss-module__VIIjUq__statusDot",
  "statusGroup": "SearchModal-module-scss-module__VIIjUq__statusGroup",
  "statusLabel": "SearchModal-module-scss-module__VIIjUq__statusLabel",
  "statusMeta": "SearchModal-module-scss-module__VIIjUq__statusMeta",
  "stickyFooter": "SearchModal-module-scss-module__VIIjUq__stickyFooter",
  "stickyHead": "SearchModal-module-scss-module__VIIjUq__stickyHead",
  "titleTag": "SearchModal-module-scss-module__VIIjUq__titleTag",
  "visuallyHidden": "SearchModal-module-scss-module__VIIjUq__visuallyHidden",
});
